export const resolveAuditClientId = (...sources) => {
  for (const source of sources) {
    if (!source) continue;
    const candidate = source?.resolvedCompanyId
      ?? source?.companyId
      ?? source?.company_id
      ?? source?.company?.id
      ?? source?.clientId
      ?? source?.client_id
      ?? source?.lead?.companyId
      ?? source?.lead?.company_id;
    if (candidate != null && String(candidate).trim() !== '') return candidate;
  }
  return null;
};

export const canEditAuditScheduling = ({ isAssignedScheduler = false, hasRole }) => (
  isAssignedScheduler
  || hasRole('ROLE_SCHEDULER')
  || hasRole('ROLE_OPERATION')
  || hasRole('ROLE_OPERATION_MANAGER')
);
